import { ButtonLink, Image, Text } from "components/commons";
import { IntegrationType } from "enums";
import { environment } from "environments/environment";
import { Key } from "images";
import { openInNewTab } from "services/url.service";
import lang from "translations";

export const IntegrationSections = {
  PROPERTY_MANAGEMENT: lang.propertyManagementSystems,
  TABLE_MANAGEMENT: lang.tableManagementAndReservations,
  ERP_ACCOUNTING: lang.erpAndAccounting,
  PAYMENT_GATEWAYS: lang.paymentGateways,
  CUSTOM: lang.customIntegrations,
};

const mewsInstruction = (
  <div>
    <Text fontWeight="font-semibold" color="text-gray" className="my-md">
      {lang.howToFindYourAccessToken}
    </Text>
    <Text className="flex">
      {lang.mewsInstructionStep1}
      <ButtonLink
        className="ml-xs"
        onClick={() => {
          openInNewTab(environment.MEWS_URL);
        }}
      >
        <Text underline color="text-pelorous">
          {lang.mewsDashboard}
        </Text>
      </ButtonLink>
    </Text>
    <Text>{lang.mewsInstructionStep2}</Text>
    <Text>{lang.mewsInstructionStep3}</Text>
    <Text>{lang.mewsInstructionStep4}</Text>
    <Text className="flex items-center">
      {lang.mewsInstructionStep5Start} <Image src={Key} /> {lang.mewsInstructionStep5End}
    </Text>
  </div>
);

const data = [
  {
    name: "Cloudbeds",
    type: lang.propertyManagementSystem,
    section: IntegrationSections.PROPERTY_MANAGEMENT,
    description: lang.cloudbedsDescription,
    imageLink: "https://assets.lightspeedhq.com/img/2018/03/CB_stacked_blue300x300.png",
    logoFallback: "cb",
    logoBackground: "#0B7FD4",
    company: "Cloudbeds",
    permissions: [
      { permissionId: 1, text: lang.permBasicVenueInformation },
      { permissionId: 2, text: lang.permBookingsAndGuestDetails },
      { permissionId: 3, text: lang.permCustomPaymentMethod },
      { permissionId: 4, text: lang.permHouseAccount },
      { permissionId: 5, text: lang.permSaleTransactions },
    ],
    privacyLink: "https://www.cloudbeds.com/en/privacy-policy",
    termsAndConditionsLink: "https://www.cloudbeds.com/en/terms",
    dashboardLink: null,
    authorizationLink: environment.CLOUDBEDS_CONNECT_URL,
    isConnected: false,
    integrationType: IntegrationType.CLOUDBEDS,
    featureFlag: "cloudbedsIntegration",
  },
  {
    name: "Mews",
    type: lang.propertyManagementSystem,
    section: IntegrationSections.PROPERTY_MANAGEMENT,
    description: lang.mewsDescription,
    imageLink: "https://www.mews.com/hubfs/Mews%20Logo_Square_Black.jpg",
    logoFallback: "M",
    logoBackground: "#111111",
    company: "Mews Systems",
    permissions: [
      { permissionId: 1, text: lang.permBasicVenueInformation },
      { permissionId: 2, text: lang.permBookingsAndGuestDetails },
    ],
    privacyLink: "https://www.mews.com/en/privacy",
    termsAndConditionsLink: "https://www.mews.com/en/privacy",
    instruction: mewsInstruction,
    dashboardLink: environment.MEWS_URL,
    guideLink:
      "https://help.mews.com/s/article/connect-and-disconnect-integrations?language=en_US&Language=en_US",
    disconnectionMessage: lang.mewsDisconnectionMessage,
    integrationType: IntegrationType.MEWS,
    featureFlag: "bookingIntegration",
  },
  {
    name: "Lobby",
    type: lang.propertyManagementSystem,
    section: IntegrationSections.PROPERTY_MANAGEMENT,
    description: lang.lobbyDescription,
    logoFallback: "L",
    logoBackground: "#12556B",
    isApp: true,
    applicationDisplayNames: ["Lobby", "Lobbypms"],
  },
  {
    name: "Zeus",
    type: lang.propertyManagementSystem,
    section: IntegrationSections.PROPERTY_MANAGEMENT,
    description: lang.zeusDescription,
    logoFallback: "Z",
    logoBackground: "#3A3F8F",
    isComingSoon: true,
  },
  {
    name: "Eat App",
    type: lang.tableManagementAndReservations,
    section: IntegrationSections.TABLE_MANAGEMENT,
    description: lang.eatAppDescription,
    logoFallback: "EA",
    logoBackground: "#E8552D",
    isComingSoon: true,
  },
  {
    name: "SevenRooms",
    type: lang.tableManagementAndReservations,
    section: IntegrationSections.TABLE_MANAGEMENT,
    description: lang.sevenRoomsDescription,
    logoFallback: "7R",
    logoBackground: "#1A1A2E",
    isComingSoon: true,
  },
  {
    name: "Odoo",
    type: lang.erpAndAccounting,
    section: IntegrationSections.ERP_ACCOUNTING,
    description: lang.odooDescription,
    logoFallback: "O",
    logoBackground: "#714B67",
    isComingSoon: true,
  },
  {
    name: "Siigo",
    type: lang.erpAndAccounting,
    section: IntegrationSections.ERP_ACCOUNTING,
    description: lang.siigoDescription,
    imageLink:
      "https://prod-socashless-assets.s3.ap-southeast-1.amazonaws.com/prod/dashboard-assets/siigo-logo.png",
    logoFallback: "S",
    logoBackground: "#12A5E8",
    company: lang.siigo,
    isConnected: false,
    isApp: true,
  },
  {
    name: "NTT DATA",
    type: lang.paymentGateway,
    section: IntegrationSections.PAYMENT_GATEWAYS,
    description: lang.nttDataDescription,
    logoFallback: "NT",
    logoBackground: "#0033A0",
    isMock: true,
    isIntegrated: true,
    contactSupportSubject: lang.nttDataPaymentGatewayEnquiry,
  },
];

export default data;
